import Component from "./ProductStatuses";

export default Component;